// Global "forbidden" state for permission failures (403) on authorized calls.
// Lives outside React so the axios interceptor (a non-React module) can flag it,
// and any component can subscribe via the useForbidden() hook.

import { useSyncExternalStore } from 'react';

type Listener = () => void;

let forbidden = false;
const listeners = new Set<Listener>();

export const setForbidden = (value: boolean): void => {
  if (forbidden === value) return;
  forbidden = value;
  listeners.forEach((listener) => listener());
};

export const getForbidden = (): boolean => forbidden;

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Subscribe a React component to the global forbidden flag. */
export const useForbidden = (): boolean =>
  useSyncExternalStore(subscribe, getForbidden);
